module.exports = __webpack_public_path__ + "static/media/maintainance.0be31d22.svg";